export default {
	pageSize: 50,
};
